import { CrudBuilderConfig } from '@core/components/crudbuilder/models/crud-builder-config';
import { FieldConfig } from '@core/components/crudbuilder/models/field-config';
import { createMortgage } from '@core/state/mortgage/mortgage.model';
import { PopularAppStatesService } from '@core/services/popular-app-states/popular-app-states.service';

export class MortgagesConfigClass extends CrudBuilderConfig {
  singular    = 'Hypotheek';
  customTitle = 'Hypotheek';
  plural      = 'Hypotheken';
  modelAlias  = 'mortgage';
  path        = 'mortgage';
  hasCustomBackRoute = true;

  fields = [
    new FieldConfig('name', FieldConfig.TYPE_STRING, 'Naam hypotheek'),
    new FieldConfig('interest_lock_period', FieldConfig.TYPE_NUMBER, 'Voor hoeveel maanden staat uw rente nog vast?'),
    new FieldConfig('home_id', FieldConfig.TYPE_HOMES, 'Onderpand'),
    new FieldConfig('start_date', FieldConfig.TYPE_DATE, 'Start Datum'),
    new FieldConfig('end_date', FieldConfig.TYPE_DATE, 'Eind Datum'),
    // new FieldConfig('duration', FieldConfig.TYPE_NUMBER, 'Rentevaste Periode'),
    new FieldConfig('amount', FieldConfig.TYPE_MONEY, 'Startbedrag Hypotheek'),
    new FieldConfig('current_amount', FieldConfig.TYPE_MONEY, 'Restant Hypotheek'),
    new FieldConfig('mortgage_type_configuration_id', FieldConfig.TYPE_MORTGAGE, 'Type Hypotheek'),
    new FieldConfig('financial_company_id', FieldConfig.TYPE_FINANCIAL_COMPANIES, 'Aanbieder'),
    new FieldConfig('life_insurance_id', FieldConfig.TYPE_LIFE_INSURANCE, 'Gekoppelde levensverzekering'),
    new FieldConfig('interest', FieldConfig.TYPE_NUMBER, 'Rente percentage'),
    // new FieldConfig('last_check_date', FieldConfig.TYPE_DATE, 'Afgenomen Bij'),
    new FieldConfig('nhg', FieldConfig.TYPE_BOOLEAN, 'NHG'),
    new FieldConfig('debt_free_pay_off', FieldConfig.TYPE_MONEY, 'Boetevrij aflossen'),
    new FieldConfig('mortgage_number', FieldConfig.TYPE_STRING, 'Hypotheeknummer'),
  ];

  readFields = [
    new FieldConfig('name', FieldConfig.TYPE_STRING, 'Naam hypotheek'),
    new FieldConfig('interest_lock_period', FieldConfig.TYPE_NUMBER, 'Voor hoeveel maanden staat uw rente nog vast?'),
    new FieldConfig('home_id', FieldConfig.TYPE_HOMES, 'Onderpand'),
    new FieldConfig('start_date', FieldConfig.TYPE_DATE, 'Start Datum'),
    new FieldConfig('end_date', FieldConfig.TYPE_DATE, 'Eind Datum'),
    // new FieldConfig('duration', FieldConfig.TYPE_NUMBER, 'Rentevaste Periode'),
    new FieldConfig('amount', FieldConfig.TYPE_MONEY, 'Startbedrag Hypotheek'),
    new FieldConfig('current_amount', FieldConfig.TYPE_MONEY, 'Restant Hypotheek'),
    new FieldConfig('mortgage_type_configuration_id', FieldConfig.TYPE_MORTGAGE, 'Type Hypotheek'),
    new FieldConfig('financial_company_id', FieldConfig.TYPE_FINANCIAL_COMPANIES, 'Aanbieder'),
    new FieldConfig('life_insurance_id', FieldConfig.TYPE_LIFE_INSURANCE, 'Gekoppelde levensverzekering'),
    new FieldConfig('interest', FieldConfig.TYPE_NUMBER, 'Rente (percentage)'),
    // new FieldConfig('last_check_date', FieldConfig.TYPE_DATE, 'Afgenomen Bij'),
    new FieldConfig('nhg', FieldConfig.TYPE_BOOLEAN, 'NHG'),
    new FieldConfig('debt_free_pay_off', FieldConfig.TYPE_MONEY, 'Boetevrij aflossen (percentage)'),
  ];

  getModel() {
    return createMortgage({});
  }

  getReadTitle(model): string {
    if (model) {
      return model.name;
    }
  }

  getCustomBackRoute() {
    return '/dashboard/fixed-charges';
  }
}

export const MortgagesCrudBuilderConfig = new MortgagesConfigClass();
